<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader title="Ecommerce Orders" title1="Online orders" />
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Order No</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Items</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in orders" :key="order.order_id">
                    <td>{{ order.order_number }}</td>
                    <td>{{ formatDate(order.created_at) }}</td>
                    <td><span class="badge bg-info">{{ order.status }}</span></td>
                    <td>{{ (order.items || []).length }}</td>
                    <td>{{ money(order.total_amount) }}</td>
                  </tr>
                  <tr v-if="!loading && orders.length === 0">
                    <td colspan="5" class="text-center text-muted py-4">No ecommerce orders found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ecommerce-orders',
  data() {
    return {
      loading: false,
      orders: [],
    };
  },
  mounted() {
    this.loadOrders();
  },
  methods: {
    async loadOrders() {
      this.loading = true;
      try {
        const response = await axios.get('/v1/ecommerce/orders');
        this.orders = response.data || [];
      } finally {
        this.loading = false;
      }
    },
    money(value) {
      const amount = Number(value || 0);
      return amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },
    formatDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleString();
    },
  },
};
</script>
